import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContainerModule } from 'ng-labs/container';
import { FooterComponent } from './footer.component';

@NgModule({
  imports: [CommonModule, ContainerModule],
  exports: [FooterComponent],
  declarations: [FooterComponent],
  providers: []
})
export class FooterModule {}
